import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TraceIdService {
    private traceIdSubject = new BehaviorSubject<string | null>(null);
    public traceId$ = this.traceIdSubject.asObservable();

    get currentTraceId(): string | null {
        return this.traceIdSubject.value;
    }

    setTraceId(id: string | null): void {
        this.traceIdSubject.next(id);
    }
}
